<template>
  <div v-if="shopData && activityId" class="details-page">
    <div @click="back" class="back">返回</div>
    <!-- swipper 轮播组件 -->
    <Banner :mediaFiles="mediaFiles" />
    <!-- 轮播组件下面的那个白条 -->
    <div class="swiper-wrapper-bottom"></div>
    <!-- 信息点其他消息部分 -->
    <Infos :infos="infos" />
    <!-- 信息点内容部分 -->
    <div class="no-thing" v-if="content.introduce"></div>
    <Contents :content="content" v-if="content.introduce" />
    <!-- 底部tool -->
    <Footer :footer="footer" class="detail-footer" :mainInfo="detailsInfo" />
    <Artifact-list v-if="shopData" :handleClickArtifactItem="handleClickArtifactItem" :activityInfo="activityInfo" :storeInfo="shopData" />
    <!-- 获取信息点部分，这应该是一个隐蔽的部分，感觉是不是做成一个mixin -->
    <div style="position: fixed; bottom: -5000px" class="map-container-fake"></div>
  </div>
</template>

<script>
import Banner from './components/Banner'
import Infos from './components/Infos'
import Contents from './components/Contents'
import Footer from './components/Footer'
import ArtifactList from '../HomePage/components/ArtifactList'

import openApp from '@/utils/openApp.js'
import { getShopDetail, detailPageVisitor } from '@/server/interfaces'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import setDocuemntTtitle from '@/utils/setDocumentTitle'
import { getDistance } from '@/utils/amap'
import { initShare } from '@/utils/share'

export default {
  components: { Banner, Infos, Contents, Footer, ArtifactList },
  data () {
    return {
      shopData: null,
      activityInfo: null,
      modulesMatchData: null,
      isOpenLink: false,
      userPosition: null,
      defaultPosition: {
        latitude: 23.137,
        longitude: 113.325,
        valid: true
      },
      mediaFiles: [],
      infos: {
        name: '', // 标题
        openingHours: '', // 开发时间
        address: '', // 地址
        distance: '' // 距离
      },
      content: {
        introduce: ''
      },
      footer: {},
      detailsInfo: {}
    }
  },
  async created () {
    this.getShopDetail(this.$route.query.shopId)
    detailPageVisitor({ id: this.$route.query.shopId })
  },
  async mounted () {
    try {
      this.showLoading()
      if (this.userPosition) {
        this.hideLoading()
      } else {
        await this.getUserPosition()
      }
    } catch (e) {
      window.console.error(e)
    }
  },
  watch: {
    userPosition (newValue) {
      if (newValue) {
        this.hideLoading()
      }
    }
  },
  computed: {
    ...mapGetters({
      activityId: 'activityInfo/activityId'
    }),
    modules () {
      return this.$refs.modules
    }
  },
  methods: {
    ...mapMutations({
      toast: 'toast/showToast',
      showLoading: 'loading/showLoading',
      hideLoading: 'loading/hideLoading',
      setShareInfo: 'activityInfo/setShareInfo'
    }),
    ...mapActions({
      initNfPluseShare: 'activityInfo/initNfPluseShare'
    }),
    handleClickArtifactItem (id) {
      this.getShopDetail(id)
    },
    openLink (e) {
      const target = e.target
      if (target.dataset.src) {
        this.iframSrc = target.dataset.src
        this.isOpenLink = true
      }
    },
    getUserPosition () {
      /* global AMap */
      this.map = new AMap.Map('map-container-fake', {
        center: [113.325, 23.137]
      })
      this.map.plugin('AMap.Geolocation', () => {
        const geolocation = new AMap.Geolocation({
          enableHighAccuracy: true, // 是否使用高精度定位，默认:true
          timeout: 10000, // 超过10秒后停止定位，默认：无穷大
          maximumAge: 0, // 定位结果缓存0毫秒，默认：0
          convert: true, // 自动偏移坐标，偏移后的坐标为高德坐标，默认：true
          showButton: false, // 显示定位按钮，默认：true
          showMarker: true, // 定位成功后在定位到的位置显示点标记，默认：true
          showCircle: true, // 定位成功后用圆圈表示定位精度范围，默认：true
          panToLocation: true, // 定位成功后将定位到的位置作为地图中心点，默认：true
          zoomToAccuracy: true // 定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
        })
        this.map.addControl(geolocation)
        geolocation.getCurrentPosition()
        AMap.event.addListener(geolocation, 'complete', this.onComplete) // 返回定位信息
        AMap.event.addListener(geolocation, 'error', this.onError) // 返回定位出错信息
      })
    },
    onComplete (obj) {
      this.userPosition = {
        latitude: obj.position.lat,
        longitude: obj.position.lng,
        valid: true
      }
      this.getInfoDistance()
    },
    onError (obj) {
      window.console.log(obj)
      this.userPosition = this.defaultPosition // 获取不到定位，默认用这个定位
      this.getInfoDistance()
    },
    back () {
      if (this.isOpenLink) {
        this.isOpenLink = false
      } else {
        this.$router.push({ path: '/homePage', query: { id: this.activityId, shopId: this.$route.query.shopId } })
      }
    },
    downLoad () {
      openApp({
        address: window.location.href
      }, this.activityId, 39)
    },
    // 获取信息点的消息
    async getShopDetail (id) {
      try {
        const res = await getShopDetail({
          params: {
            id
          }
        })
        this.modulesMatchData = res.modules
        this.shopData = res
        // 详情数据处理
        this.dealDeatilsData(this.shopData)
        setDocuemntTtitle(this.shopData.name)
        this.setAllShareInfo()
      } catch (error) {
        this.toast(error)
        console.log('++++++', error)
      }
    },
    async setAllShareInfo () {
      this.setShareInfo({
        title: this.shopData.name,
        desc: this.shopData.introduce || document.title || '',
        link: window.location.href,
        imgUrl: this.shopData.mainImage
      })
      try {
        await this.initNfPluseShare()
      } catch (e) {
        console.log(e)
      }
      try {
        await initShare({
          shareTitle: this.shopData.name,
          shareDesc: this.shopData.address.address || document.title || '',
          shareUrl: window.location.href,
          shareIcon: this.shopData.mainImage
        })
      } catch (e) {
        console.log(e)
      }
    },
    // 详情数据处理逻辑
    dealDeatilsData (detailsInfo) {
      // 获取轮播图数据
      this.detailsInfo = detailsInfo
      if (detailsInfo && detailsInfo.redTemplate) {
        // 轮播图数据
        this.mediaFiles = [...(detailsInfo.redTemplate?.imgs || []), ...(detailsInfo.redTemplate?.videos || [])]
        // 景点相关数据
        this.infos.name = detailsInfo.name
        this.infos.openingHours = detailsInfo.redTemplate.openingHours || ''
        this.infos.address = detailsInfo.address.address || ''
        this.getInfoDistance()
        // 主要内容数据
        this.content.introduce = detailsInfo.redTemplate.introduce || ''
        // 底部按钮数据
        this.footer = detailsInfo.redTemplate.fnModule
      }
    },
    getInfoDistance () {
      if (!this.userPosition || !this.detailsInfo.address?.point) return
      this.infos.distance = getDistance(
        { lng: this.detailsInfo.address.point.x, lat: this.detailsInfo.address.point.y },
        { lng: this.userPosition?.longitude, lat: this.userPosition?.latitude }
      )
    }
  }
}
</script>

<style scoped="scoped" lang="scss">
.details-page {
  width: 100%;
  height: 100vh;
  background: #fff;
  .no-thing {
    width: 100%;
    height: 0.1rem;
    background: #f5f4f4;
  }
  .back {
    width: 1rem;
    height: 0.64rem;
    background: rgba(0, 0, 0, 0.8);
    border-radius: 0 38px 38px 0;
    position: fixed;
    left: 0;
    top: 0.3rem;
    z-index: 9999;
    font-family: PingFangSC-Regular;
    font-size: 0.3rem;
    line-height: 0.66rem;
    text-align: center;
    color: #ffffff;
    letter-spacing: 0;
  }
  .detail-footer {
    height: 1.37rem;
    overflow: hidden;
    width: 100%;
    border-top: 1px solid #eee;
    padding: 0 0.4rem;
    z-index: 3;
    position: fixed;
    bottom: 0;
    justify-content: space-around;
  }
  .swiper-wrapper-bottom {
    width: 100%;
    height: 0.2rem;
    border-radius: 0.2rem 0.2rem 0 0;
    background: #fff;
    position: absolute;
    top: 3.62rem;
    z-index: 2;
  }
}
</style>
